type RequestClassBase = { [key: string]: any };

type ValidationErrorInternalError<RequestClass extends RequestClassBase> =
  string | { [key in keyof RequestClass]: string };

export class ValidationError<RequestClass extends RequestClassBase> {
  _error: ValidationErrorInternalError<RequestClass>;

  constructor(error: ValidationErrorInternalError<RequestClass>) {
    this._error = error;
  }

  toString(): string {
    return (
      typeof this._error === "string"
        ? this._error
        : Object.values(this._error).join(". ")
    )
      .replace("Validation Error:", "")
      .replace("Error:", "")
      .trim();
  }
}

export class PaymentRequiredError extends Error {
  public readonly response: unknown;

  constructor(responseData: unknown) {
    super("Payment Required");

    this.response = responseData;
  }
}

export class DuplicateEmailError extends Error {}

// Thrown by the response interceptor when a request got no response at
// all (offline, DNS failure, timeout). Several screens render errors via
// toString(), so both message and toString are customer-ready copy.
export class NoConnectionError extends Error {
  constructor() {
    super(
      "We couldn't connect. Please check your internet connection and try again.",
    );
  }

  toString(): string {
    return this.message;
  }
}
